'use client';

import { useCallback, useState } from 'react';

export interface ConfirmationConfig {
  title: string;
  description: string;
  confirmLabel?: string;
  cancelLabel?: string;
  variant?: 'default' | 'danger';
}

type Resolver = (value: boolean) => void;

export function useConfirmation() {
  const [isOpen, setIsOpen] = useState(false);
  const [config, setConfig] = useState<ConfirmationConfig | null>(null);
  const [resolver, setResolver] = useState<Resolver | null>(null);

  const confirm = useCallback((cfg: ConfirmationConfig): Promise<boolean> => {
    setConfig(cfg);
    setIsOpen(true);
    return new Promise<boolean>((resolve) => {
      setResolver(() => resolve);
    });
  }, []);

  const handleConfirm = useCallback(() => {
    resolver?.(true);
    setIsOpen(false);
    setResolver(null);
    setConfig(null);
  }, [resolver]);

  const handleCancel = useCallback(() => {
    resolver?.(false);
    setIsOpen(false);
    setResolver(null);
    setConfig(null);
  }, [resolver]);

  return {
    isOpen,
    config,
    confirm,
    onConfirm: handleConfirm,
    onCancel: handleCancel,
  };
}